import ErrorText from '../ErrorText';
import Form from '../AuthForm';
import Input from '../AuthInput';
import { useTranslation } from 'react-i18next';

type Props = {
  error: string;
  handleChange(e: string): void;
  email: string;
  isEmailValid: boolean;
};

const EmailForm = ({ email, error, handleChange, isEmailValid }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Form>
      <ErrorText>{error}</ErrorText>
      <Input
        label={t('auth.email')}
        type="email"
        value={email}
        handleChange={handleChange}
        error={Boolean(email && !isEmailValid)}
      />
    </Form>
  );
};

export default EmailForm;
